import React, { ReactNode, useMemo } from 'react';
import {
  DepositStatuses,
  TransferFilterType,
  WithdrawalStatuses,
} from '../../apis/transfers/types';
import { ZigTypography } from '@zignaly-open/ui';
import { depositStatusColorMap, withdrawalStatusColorMap } from './constants';
import { useTranslation } from 'react-i18next';

export const useOperatorOptions = () => {
  return useMemo<{ value: TransferFilterType['operator']; label: string }[]>(
    () => [
      { value: 'eq', label: '=' },
      { value: 'gt', label: '>' },
      { value: 'lt', label: '<' },
      { value: 'gte', label: '>=' },
      { value: 'lte', label: '<=' },
    ],
    [],
  );
};

export const useDepositStatusOptions = () => {
  const { t } = useTranslation('transfers');
  return useMemo<{ value: DepositStatuses | ''; label: ReactNode | string }[]>(
    () => [
      { value: '', label: t('common:all') },
      ...[
        DepositStatuses.STATUS_FAILED,
        DepositStatuses.STATUS_COMPLETED,
        // DepositStatuses.STATUS_PENDING,
      ].map((value) => ({
        value,
        label: (
          <ZigTypography fontSize={'11px'} color={depositStatusColorMap[value]}>
            {t(`depositStatuses.${value}`)}
          </ZigTypography>
        ),
      })),
    ],
    [t],
  );
};

export const useWithdrawalStatusOptions = () => {
  const { t } = useTranslation('transfers');
  return useMemo<
    { value: WithdrawalStatuses | ''; label: ReactNode | string }[]
  >(
    () => [
      { value: '', label: t('common:all') },
      ...[
        WithdrawalStatuses.STATUS_FAILED,
        WithdrawalStatuses.STATUS_COMPLETED,
        // WithdrawalStatuses.STATUS_PENDING,
      ].map((value) => ({
        value,
        label: (
          <ZigTypography
            fontSize={'11px'}
            color={withdrawalStatusColorMap[value]}
          >
            {t(`withdrawalStatuses.${value}`)}
          </ZigTypography>
        ),
      })),
    ],
    [t],
  );
};
